import React, { useState, useEffect } from 'react';
import * as api from '../../utils/api';
import styles from './ReferralPage.module.css';
import { FaCopy, FaWhatsapp, FaTelegramPlane, FaRegHandshake, FaUserPlus, FaWallet, FaGift } from 'react-icons/fa';
import MessageBox from '../../components/MessageBox';

const ReferralPage = () => {
  const [referralCode, setReferralCode] = useState('');
  const [copied, setCopied] = useState(false);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data } = await api.getUser();
        if (data) {
          if (data.referralCode) {
            setReferralCode(data.referralCode);
          } else if (data.name && data.mobileNumber) {
            const firstName = data.name.split(' ')[0];
            const lastFourDigits = data.mobileNumber.slice(-4);
            setReferralCode(`${firstName.toUpperCase()}${lastFourDigits}`);
          }
        }
      } catch (err) {
        console.error("Error fetching user for referral:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  const handleCopy = () => {
    if (!referralCode) return;
    navigator.clipboard.writeText(referralCode);
    setCopied(true);
    setMessage({ type: 'success', text: 'Referral code copied!' });
    setTimeout(() => {
      setCopied(false);
      setMessage(null);
    }, 2000);
  };

  const shareText = `Join me on ${process.env.REACT_APP_NAME} and start trading! Use my referral code: ${referralCode}`;

  if (loading) return <div className={styles.loading}>Loading...</div>;

  return (
    <div className={styles['referral-page']}>
      {message && <MessageBox message={message.text} type={message.type} onClose={() => setMessage(null)} />}

      <div className={styles['main-card']}>
        <div className={styles['card-header']}>
          <div className={styles['gift-icon-container']}>
            <FaGift />
          </div>
          <h1>Refer & Earn</h1>
          <p>Invite friends to {process.env.REACT_APP_NAME} and earn rewards</p>
          <div className={styles['reward-amount']}>
            <span>You both get up to</span>
            <strong>₹1,000</strong>
          </div>
        </div>

        <div className={styles['how-it-works-mini']}>
          <div className={styles['mini-step']}>
            <div className={styles['mini-icon']}><FaUserPlus /></div>
            <span>Invite</span>
          </div>
          <div className={styles['mini-divider']}></div>
          <div className={styles['mini-step']}>
            <div className={styles['mini-icon']}><FaRegHandshake /></div>
            <span>Sign Up</span>
          </div>
          <div className={styles['mini-divider']}></div>
          <div className={styles['mini-step']}>
            <div className={styles['mini-icon']}><FaWallet /></div>
            <span>Reward</span>
          </div>
        </div>

        <div className={styles['share-section']}>
          <div className={styles['code-container']}>
            <label>Your Referral Code</label>
            <div className={styles['code-display']} onClick={handleCopy}>
              <span className={styles['code-text']}>{referralCode || 'GENERATING...'}</span>
              <div className={styles['copy-btn']}>
                {copied ? 'COPIED' : <FaCopy />}
              </div>
            </div>
          </div>

          <div className={styles['social-share']}>
            <a href={`https://wa.me/?text=${encodeURIComponent(shareText)}`}
               target="_blank" rel="noopener noreferrer" className={styles['whatsapp-btn']}>
              <FaWhatsapp />
            </a>
            <a href={`https://t.me/share/url?url=${encodeURIComponent(window.location.origin)}&text=${encodeURIComponent(shareText)}`}
               target="_blank" rel="noopener noreferrer" className={styles['telegram-btn']}>
              <FaTelegramPlane />
            </a>
          </div>
        </div>

        <div className={styles['card-footer-stats']}>
          <div className={styles['stat-box']}>
            <span className={styles['stat-label']}>Total Referrals</span>
            <span className={styles['stat-value']}>0</span>
          </div>
          <div className={styles['v-divider']}></div>
          <div className={styles['stat-box']}>
            <span className={styles['stat-label']}>Total Earned</span>
            <span className={styles['stat-value']}>₹0</span>
          </div>
        </div>
      </div>

      <p className={styles['tc-text']}>*Terms and Conditions apply</p>
    </div>
  );
};

export default ReferralPage;